$(function () {
  let count = $('.section_home_carousel').attr('data-count');
  let interval = $('.section_home_carousel').attr('data-interval');
  let auto  = $('.section_home_carousel').attr('data-autoplay') == '0' ? false : true;
  let autoplay = auto;

  if (auto) {
    if (count <= 1) {
      autoplay = false
    }
    if (interval == '0') {
      autoplay = false
    }
  }
  let swiper = new window.AwesomeSwiper.Swiper('.swiper-container-showtime-index', {
    loop: true,
    spaceBetween: 0,
    // centeredSlides: true,
    crossFade: true,
    spaceBetween: 60,
    autoHeight: true,
    autoplay: autoplay ? {
      delay: interval * 1000
    } : false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    on: {
      slideChangeTransitionStart: function () {
        let title = $('.section-slideshow .swiper-wrapper .swiper-slide').eq(this.activeIndex).attr('data-title')
        let description = $('.section-slideshow .swiper-wrapper .swiper-slide').eq(this.activeIndex).attr('data-description')
        $('#showtime-banner-text2 .banner_overlay h2').text(title)
        $('#showtime-banner-text2 .banner_overlay h4').text(description)
      }
    },
  });

  $('#showtime-swiper .swiper-slide img').on("load", function () {
    swiper.update();
  })

  $(window).scroll(function () {
    if ($('#showtime-swiper').html()) {
      if ($('#showtime-swiper').offset().top && $('#showtime-swiper').offset().top < window.scrollY) {
        swiper.autoplay.stop();
      } else {
        if (autoplay) {
          swiper.autoplay.start()
        } else {
          swiper.autoplay.stop();
        }
      }
    }
  });


  if ($('.swiper-pagination .swiper-pagination-bullet').length <= 1) {
    $('.swiper-pagination .swiper-pagination-bullet').css('display', 'none')
  }




})

